<template>
  <div>
    <div class="admin cobrar">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- main -->
          <div class="col-8 main">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin mt-4">
                  <h1 class="subheading font-weight-black  mt-5">
                    PUNTO DE VENTA
                  </h1>

                  <v-btn
                    class=""
                    @click="$router.go(-1)"
                    large
                    outlined
                    color="grey"
                  >
                    <v-icon class="mr-3">close</v-icon>Salir
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- datos del cliente -->
            <div v-if="tipoCliente != 'generico'">
              <div class="row">
                <div class="col-12" style="padding-left: 20px">
                  <h5 class="font-weight-black">Datos del cliente</h5>
                </div>
              </div>

              <div class="row mt-0">
                <div
                  class="col"
                  style="padding-left: 20px; padding-top: 0; margin-top: 0"
                >
                  <v-text-field
                    label="Nombre del cliente"
                    placeholder="nombre"
                    hide-details
                    v-model="nombre_cliente"
                  ></v-text-field>
                </div>
                <div
                  class="form-group col"
                  style="padding-right: 20px; padding-top: 0; margin-top: 0"
                >
                  <v-text-field
                    label="Teléfono del cliente"
                    placeholder="(00) 000 000"
                    hide-details
                    v-model="telefono_cliente"
                  ></v-text-field>
                </div>
              </div>

              <div class="row mt-0">
                <div
                  class="col"
                  style="padding-left: 20px; padding-top: 0; margin-top: 0"
                >
                  <v-text-field
                    label="Email del cliente"
                    placeholder="@"
                    v-model="email_cliente"
                  ></v-text-field>
                </div>
                <div
                  class="col"
                  style="padding-right: 20px; padding-top: 0; margin-top: 0"
                >
                  <v-text-field
                    label="Dirección del cliente"
                    placeholder="dirección"
                    v-model="direccion_cliente"
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-12" style="padding-left: 20px">
                  <v-alert :value="true" type="info">
                    Esta venta pertenece a un Cliente genérico
                  </v-alert>
                </div>
              </div>
            </div>
            <!-- /datos del cliente -->

            <!-- servicios -->
            <div class="row mt-0">
              <div
                class="col-12"
                style="padding-left: 20px; padding-top: 0; margin-top: 0"
              >
                <h5 class="font-weight-black">Agregar servicio</h5>
              </div>
            </div>

            <div class="row mt-0 column-direction">
              <div
                class="col"
                style="padding-left: 20px; padding-top: 0; margin-top: 0"
              >
                <v-text-field
                  label="Concepto del servicio"
                  placeholder="concepto"
                  v-model="concepto_servicio"
                ></v-text-field>
              </div>
              <div
                class="col"
                style="padding-right: 20px; padding-top: 0; margin-top: 0"
              >
                <v-text-field
                  label="Precio del servicio"
                  placeholder="$"
                  v-model="precio_servicio"
                  type="number"
                ></v-text-field>
              </div>

              <div class="col mt-2" style="margin-top: 0px; padding-top: 0">
                <v-btn
                  color="blue darken-2"
                  @click="agregarServicioOrden()"
                  large
                  block
                  dark
                >
                  <v-icon class="mr-3">add</v-icon>Agregar
                </v-btn>
              </div>
            </div>
            <!-- /servicios -->

            <!-- productos -->
            <div class="row mt-0">
              <div
                class="col-12"
                style="padding-left: 20px; padding-top: 0; margin-top: 0"
              >
                <h5 class="font-weight-black">Selecciona los productos</h5>
              </div>
            </div>

            <div class="row mt-0">
              <v-text-field
                label="Buscador productos"
                placeholder="buscador"
                style="padding-left: 20px; padding-right: 20px"
                prepend-inner-icon="search"
                @keyup="buscarConsulta()"
                v-model="buscar"
              ></v-text-field>

              <!-- loader -->
              <div
                v-if="loader"
                class="text-center loader-wrap"
                style="width: 100%"
              >
                <div
                  class="spinner-border text-primary"
                  style="width: 75px; height: 75px"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <!-- /loader -->

              <div v-else style="width: 100%">
                <!-- vacio -->
                <div v-if="productos == ''">
                  <div class="vacio">
                    <span>No hemos encontrado productos</span>
                  </div>
                </div>
                <!-- /vacio -->

                <!-- no vacio -->
                <div v-else class="productos">
                  <!-- producto -->
                  <div
                    style="min-height: 530px; background:white;"
                    class="producto_admin"
                    v-for="(item, index) in productos"
                    :key="item.producto_id"
                  >
                    <div class="imagen">
                      <img
                        style="padding: 75px"
                        v-if="item.imagen_destacada == ''"
                        src="https://vossmueblerias.com.mx/assets/images/logo.png"
                        alt
                      />
                      <img v-else :src="item.imagen_destacada" alt />
                    </div>
                    <div class="info-wrap">
                      <div class="cat">
                        <span class="caption">{{ item.categoria }}</span>
                      </div>
                      <div class="nombre">
                        <span>{{ item.nombre }}</span>
                      </div>
                      <div v-if="item.inventario > 0" class="stock">
                        <span>unidades en stock: {{ item.inventario }}</span>
                      </div>
                      <div v-if="item.inventario == 0" class="no-stock">
                        <span>unidades en stock: {{ item.inventario }}</span>
                      </div>
                      <div
                        class="precio"
                        v-if="item.precio_oferta_pesos != 0.0"
                      >
                        <div>
                          <span
                            class="font-weight-black"
                            style="text-decoration: line-through;"
                          >
                            ${{ item.precio_pesos }}
                            <span class="small">pesos</span>
                          </span>
                        </div>
                        <div>
                          <span class="font-weight-black" style="color:red;">
                            ${{ item.precio_oferta_pesos }}
                            <span class="small">pesos</span>
                          </span>
                        </div>
                      </div>
                      <div class="precio" v-else>
                        <span class="font-weight-black">
                          ${{ item.precio_pesos }}
                          <span class="small">pesos</span>
                        </span>
                      </div>

                      <div class="button" v-if="item.inventario != 0">
                        <span
                          class="btn btn-sm btn-primary"
                          @click="
                            agregarProductoOrden(
                              item.producto_id,
                              item.precio_pesos,
                              item.precio_oferta_pesos,
                              item.imagen_destacada,
                              item.nombre
                            )
                          "
                          >AGREGAR PRODUCTO</span
                        >
                      </div>
                      <div class="button" v-if="item.inventario == 0">
                        <button class="btn btn-sm btn-secondary" disabled>
                          AGOTADO
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- /producto -->
                </div>
                <!-- /no vacio -->
              </div>
            </div>
            <!-- /productos -->
          </div>
          <!-- /main -->

          <!-- sidebar ventas -->
          <div class="col-4">
            <div class="sidebar-venta">
              <div class="top">
                <h4>Artículos</h4>

                <h6 class="font-weight-black">Productos</h6>
                <!-- alerta por no haber agregado productos -->
                <div v-if="items == ''">
                  <v-alert dense text type="warning"
                    >Nos has agregado productos aún</v-alert
                  >
                </div>
                <!-- /alerta por no haber agregado productos -->
                <div class="productos-list" v-if="items != ''">
                  <ul>
                    <!-- item -->
                    <li v-for="(item, index) in items" :key="item.id">
                      <div class="left">
                        <img
                          v-if="item.imagen == ''"
                          style="padding: 0"
                          src="https://vossmueblerias.com.mx/assets/images/logo.png"
                          alt
                        />
                        <img v-else style="padding: 0" :src="item.imagen" alt />
                        <span class="body-1">{{ item.nombre }}</span>
                      </div>

                      <div class="right">
                        <div class="precio">
                          <span
                            v-if="item.precio_oferta != '0.00'"
                            style="text-decoration:line-through; padding-right: 10px;"
                            >${{ item.precio }}</span
                          >
                          <span v-else> ${{ item.precio }} </span>

                          <span
                            v-if="item.precio_oferta != '0.00'"
                            style="color:red;"
                            >${{ item.precio_oferta }}</span
                          >
                        </div>
                        <!--<div class="numero">
                            <input type="number" :value="item.cantidad" min="1" />
                            <span>Cantidad</span>
                        </div>-->
                        <div class="borrar" @click="borrarItem(index)">
                          <i class="material-icons">delete_forever</i>
                        </div>
                      </div>
                    </li>
                    <!-- /item -->
                  </ul>
                </div>
              </div>

              <div class="bottom">
                <h2>
                  <div v-if="total == ''">
                    <span class="big">T. $0.00</span>
                  </div>
                  <div v-else>
                    <span class="big">T. ${{ total }}</span>
                  </div>
                </h2>
                <v-btn
                  class="mt-3"
                  @click="saveVenta()"
                  block
                  large
                  color="green"
                  dark
                >
                  <v-icon class="mr-3">payment</v-icon>Actualizar venta
                </v-btn>
              </div>
            </div>
          </div>
          <!-- /sidebar ventas -->
        </div>
      </div>
    </div>
    <!-- /desktop -->
  </div>
</template>

<script>
import { type } from "os";
import DatePicker from "vue2-datepicker";
const axios = require("axios");
import router from "@/router";

export default {
  components: { DatePicker },
  data() {
    return {
      cobrar: false,
      tipoCliente: "generico",
      loader: false,
      productos: "",
      buscar: "",
      total: "",
      totalSinDescuento: "",
      totalConDescuento: "",
      precio_servicio: "",
      concepto_servicio: "",
      id: this.$route.params.id,

      //Cliente
      nombre_cliente: "",
      telefono_cliente: "",
      email_cliente: "",
      direccion_cliente: "",
      loaderVenta: false,

      buscar: "",
      buscarVentaInput: "",

      hoy: "",

      ventas: "",
      loaderVentas: false,

      items: [],
    };
  },
  methods: {
    buscarConsulta() {
      this.loader = true;
      if (this.buscar != "") {
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchProducto&search=" +
              this.buscar
          )
          .then((response) => {
            this.loader = false;
            this.productos = response.data;
          })
          .catch((error) => console.log(error));
      } else {
        //Obtenemos las productos
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
          )
          .then((response) => {
            this.productos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));
      }
    },
    getProductos() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
        )
        .then((response) => {
          console.log(response.data);
          this.productos = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    agregarProductoOrden(producto_id, precio, precio_oferta, imagen, nombre) {
      //Agregamos el item  al array
      this.items.push({
        id_producto: producto_id,
        precio: precio,
        precio_oferta: precio_oferta,
        imagen: imagen,
        cantidad: 1,
        nombre: nombre,
        tipo: "producto",
      });

      this.updateTotal();
      this.getTotalSinDescuento();
      this.getTotalConDescuento();
    },
    agregarServicioOrden() {
      if (this.precio_servicio != "" && this.concepto_servicio != "") {
        //Agregamos el item  al array
        this.items.push({
          id_producto: "0",
          precio: this.precio_servicio,
          precio_oferta: this.precio_servicio,
          imagen: "https://vossmueblerias.com.mx/assets/images/logo.png",
          cantidad: 1,
          nombre: this.concepto_servicio,
          tipo: "servicio",
        });

        this.updateTotal();
        this.getTotalSinDescuento();
        this.getTotalConDescuento();
      } else {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Llena los campos necesarios para el servicio",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    borrarItem(index) {
      this.items.splice(index, 1);
      this.updateTotal();
      this.getTotalSinDescuento();
      this.getTotalConDescuento();
    },
    updateTotal() {
      let sum = 0;

      for (let i = 0; i < this.items.length; i++) {
        console.log(this.items[i].precio_oferta);
        let precio_final =
          this.items[i].precio_oferta != "0.00"
            ? this.items[i].precio_oferta
            : this.items[i].precio;

        sum += parseFloat(precio_final) * parseFloat(this.items[i].cantidad);
      }

      this.total = sum;
    },
    getTotalSinDescuento() {
      let sum = 0;

      for (let i = 0; i < this.items.length; i++) {
        sum +=
          parseFloat(this.items[i].precio) * parseFloat(this.items[i].cantidad);
      }

      this.totalSinDescuento = sum;
    },
    getTotalConDescuento() {
      let sum = 0;

      for (let i = 0; i < this.items.length; i++) {
        sum +=
          parseFloat(this.items[i].precio_oferta) *
          parseFloat(this.items[i].cantidad);
      }

      this.totalConDescuento = sum;
    },
    getVentaData() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaData&id=" +
            this.id
        )
        .then((response) => {
          this.nombre_cliente = response.data.cliente;
          this.telefono_cliente = response.data.telefono;
          this.monto = response.data.monto;
          this.montoConDescuento = response.data.monto_descuento;
          this.montoSinDescuento = response.data.monto_sin_descuento;
          this.direccion_cliente = response.data.direccion;
          this.email_cliente = response.data.email;
        })
        .catch((error) => console.log(error));
    },
    getVentaProductosData() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaItems&id=" +
            this.id
        )
        .then((response) => {
          console.info("==== PRODUCTOS DE LA VENTA ====");

          if (Array.isArray(response.data) && response.data.length > 0) {
            response.data.map((item, index) => {
              console.log(item);
              this.agregarProductoOrden(
                item.id_producto,
                item.precio,
                item.precio_oferta,
                item.imagen,
                item.nombre
              );
            });
          }
        })
        .catch((error) => console.log(error));
    },
    saveVenta() {
      this.items_j = JSON.stringify(this.items);
      this.loaderVenta = true;

      axios
        .post(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php",
          {
            ot: "updateVenta",
            items: this.items_j,
            total: this.total,
            totalSinDescuento: this.totalSinDescuento,
            totalConDescuento: this.totalConDescuento,
            id_venta: this.id,
          }
        )
        .then((response) => {
          console.log(response);
          //Reseteamos valores
          this.laderVenta = false;
          this.$swal({
            type: "success",
            title: "La venta se actualizó exitosamente",
            class: "arriba",
            showConfirmButton: false,
            timer: 1500,
          });
          router.push({
            name: "venta_admin",
            params: { id: this.id },
          });
        })
        .catch((error) => console.log(error));
    },
  },

  computed: {
    updateCantidadItem(index, cantidad) {
      console.log(cantidad);
      this.items[index].cantidad = cantidad;
    },
  },

  mounted() {
    this.getProductos();
    //TODO
    //Traer venta
    this.getVentaData();
    this.getVentaProductosData();
  },
};
</script>
